import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from './PatientEnrollment.module.css';
import { PlusIcon } from '../../components/icons/Icons';
import EnrollmentRuleSetupCard from './components/EnrollmentRuleSetupCard';
import { setStateValue } from './PatientModalitiesSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import errorStyles from '../program-management/ProgramManagement.module.css';
import { showAlert } from '../../components/PerinHealthAlertSlice';

const EnrollmentRules = ({errors}) => {
    const dispatch = useDispatch();
    const { devices, viewing } = useSelector((state)=>state.enrollPatientProgram);
    const modState = useSelector((state)=>state.patientEnrollmentModalities);
    const { notifications, modalityFrequencies } = useSelector((state)=>state.patientEnrollmentModalities);
    const initModalities = () => {
        const modalitiesList = [];
        const seenIds = new Set();
        modState.modalities.forEach((mod)=>{
            if ((mod.lowerLimit !== 0 || mod.upperLimit !== 0) && mod.deviceId === 1) {
                if (!seenIds.has(mod.modalityId)) {
                    seenIds.add(mod.modalityId);
                    modalitiesList.push({ value: mod.modalityId, label: mod.modalityName });
                }
            }
        })
        return modalitiesList;
    };
    
    const allModalities = initModalities();

    const notificationTemplate = {
        ruleType: "enrollment",
        actionType: "sendNotification",
        modalityId: 0,
        thresholdCount: 1,
        timeFrequency: 1,
        timeInterval: "day",
        thresholdType: "outside",
    };

    const modalityFrequencyTemplate = {
        ruleType: "enrollment",
        actionType: "increaseFrequency",
        modalityId: 0,
        thresholdType: "above",
        thresholdCount: 1,
        timeFrequency: 1,
        timeInterval: "day",
        frequencyMultiplier: 1,
        frequencyDurationValue: 1,
        frequencyDurationUnit: "hour"
    };

    const addNotification = () => {
        if ((modalityFrequencies.length + notifications.length) === 20) {
            dispatch(showAlert({
                header: "Enrollment Rules Max",
                message: "You have reached the maximum number of enrollment rules allowed (20)",
                type: 'danger',
            }))
            return;
        }
        const newNotification = notificationTemplate;
        const tempNotifications = [...notifications];
        tempNotifications.push(newNotification);
        dispatch(setStateValue({key:"notifications",value:tempNotifications}));
    };

    const addModalityFrequency = () => {
        if ((modalityFrequencies.length + notifications.length) === 20) {
            dispatch(showAlert({
                header: "Enrollment Rules Max",
                message: "You have reached the maximum number of enrollment rules allowed (20)",
                type: 'danger',
            }))
            return;
        }
        const newModalityFrequency = modalityFrequencyTemplate;
        const tempModalityFrequencies = [...modalityFrequencies];
        tempModalityFrequencies.push(newModalityFrequency);
        dispatch(setStateValue({key:"modalityFrequencies",value:tempModalityFrequencies}));
    };

    return (
        <div style={{display:"flex", flexDirection:"column", gap:"10px", paddingBottom:"10px" }}>
            <span className="subtitle-2" style={{color:"#4F4F4F", paddingTop:"10px"}}>{"Notification"}</span>
            <span className="body-2" style={{color:"#4F4F4F", paddingBottom:"10px"}}>{`Set notification frequency for the devices ${devices.length===0 ? " - No Devices Selected" : ""}`}</span>
            {errors.repeatNotificationShowing &&
                <div className={errorStyles.ValidationMessageContainer}>
                    <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" size="xs" style={{ color: "red" }} />
                    <span className={errorStyles.ValidationMessage}>{errors.repeatNotificationMessage}</span>
                </div>
            }
            {devices.length!==0 &&
                <div style={{display:"flex", flexDirection:"column", gap:"10px", paddingLeft: "10px"}}>
                    {notifications.map((notification, index)=>(
                        <EnrollmentRuleSetupCard 
                            options={allModalities} 
                            modalityId={notification.modalityId} 
                            key={index} 
                            errorShowing={errors.notificationSelectionShowing}
                            type="sendNotification"
                        />
                    ))}
                    {!viewing &&
                        <button onClick={addNotification} disabled={allModalities.length === 0} className={styles.AddNotificationButton}>
                            <PlusIcon color="#00162E"/>Add
                        </button>
                    }
                </div>
            }
            <span className="subtitle-2" style={{color:"#4F4F4F", paddingTop:"10px"}}>{"Modality Frequency"}</span>
            {errors.repeatModalityFrequencyShowing &&
                <div className={errorStyles.ValidationMessageContainer}>
                    <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" size="xs" style={{ color: "red" }} />
                    <span className={errorStyles.ValidationMessage}>{errors.repeatModalityFrequencyMessage}</span>
                </div>
            }
            {devices.length!==0 &&
                <div style={{display:"flex", flexDirection:"column", gap:"10px", paddingLeft: "10px"}}>
                    {modalityFrequencies.map((mod, index)=>(
                        <EnrollmentRuleSetupCard 
                            options={allModalities} 
                            modalityId={mod.modalityId} 
                            key={index} 
                            errorShowing={errors.modFrequencySelectionShowing} 
                            type="increaseFrequency"
                        />
                    ))}
                    {!viewing &&
                        <button onClick={addModalityFrequency} disabled={allModalities.length === 0} className={styles.AddNotificationButton}>
                            <PlusIcon color="#00162E"/>Add
                        </button>
                    }
                </div>
            }
        </div>
    )
}

export default EnrollmentRules;